import React from "react";
import { cn } from "@fmc-digital/ui";
import {
  registerStepHeaderContainerStyles,
  registerStepHeaderTitleStyles,
  registerStepHeaderSubtitleStyles,
} from "@/pages/register/register-flow.styles";

export interface RegisterStepHeaderProps {
  title: string;
  subtitle: string;
  className?: string;
  subtitleClassName?: string;
}

export const RegisterStepHeader: React.FC<RegisterStepHeaderProps> = ({
  title,
  subtitle,
  className,
  subtitleClassName,
}) => (
  <div className={cn(registerStepHeaderContainerStyles(), className)} data-testid="register-step-header">
    <h1 className={cn(registerStepHeaderTitleStyles())}>{title}</h1>
    <p className={cn(registerStepHeaderSubtitleStyles(), subtitleClassName)}>{subtitle}</p>
  </div>
);
